/**
 * Import Lodash
 */
global._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
global.axios = require('axios');

/**
 * Import jQuery
 *
 * jQuery is imported in the webpack.mix.js file
 * however it needs the following line to declare the $ (etc.) so that scripts can access it ...
 */
global.$ = global.jQuery = require('jquery');

import 'jquery-ui/ui/widget.js';
import 'jquery-ui/ui/widgets/draggable.js';
import 'jquery-ui/ui/widgets/droppable.js';
// import 'jquery-ui/ui/widgets/sortable.js';
import 'jquery-ui/ui/widgets/dialog.js';

/**
 * Import slick
 */
global.slick = require('slick-carousel');

/**
 * Import Chart
 */
global.Chart = require('chart.js/auto');

/**
 * Import Sortable
 */
global.Sortable = require('sortablejs/Sortable');

/**
 * Import jQuery cropper
 */
global.cropper = require('jquery-cropper');

/**
 * Import dropzone
 */
global.dropzone = require('dropzone');

/**
 * Import moment
 */
global.moment = require('moment');

/**
 * Import Luxon, replacement for moment
 */
global.luxon = require('luxon');
global.DateTime = luxon.DateTime;

/**
 * Import Livewire sortable plugin - https://github.com/livewire/sortable
 */
global.sortable = require('livewire-sortable');
